module.exports = __webpack_public_path__ + "img/blundstone_500.a9b72a7d.webp";